export default __webpack_public_path__ + "static/media/hotel-out-5.4d63ad2b.jpg";